import React from 'react';
import { useSelector } from 'react-redux';

import useFilter from '@hooks/useFilter';

import Checkbox from '@features/filter/v2/Checkbox';
import FilterName from '@features/filter/v2/FilterName';

const BrandSpecific = ({ filterPageName }) => {
	const { dependentFilterList } = useSelector((store) => store.dependentFilterListStore);
	const { data, handleSearch } = useFilter(filterPageName, dependentFilterList?.brandList);

	const options = data.map((item) => ({
		...item,
		count: item?.count
	}));

	return (
		<>
			<FilterName type="BRAND_SPECIFIC" />
			<Checkbox data={options} type="BRAND_SPECIFIC" handleSearch={handleSearch} />
		</>
	);
};

export default BrandSpecific;
